module.exports = __webpack_public_path__ + "static/media/suki-vertical.b3360f58.svg";